import React from "react" ;
import { ReactNode } from "react" ;
import ObservableState from "../utils/ObservableState" ;
import * as ui from "../native" ;
import ObservableComponent from "./ObservableComponent" ;
import BaseUIProps , { copyBaseUIProps } from "../native/ui/BaseUIProps" ;
import CallData from "../classes/CallData" ;
import ResultStatus from "../classes/ResultStatus" ;
import Popup from "./Popup" ;
import User from "../models/User" ;
import CallInteraction from "../classes/CallInteraction" ;
import LeadUtils from "../classes/LeadUtils" ;
import Result from "../classes/Result" ;
import PaginationView from "./PaginationView" ;
import Query from "../classes/Query" ;
import HotListLeads from "../classes/HotListLeads" ;
import MessageDispatch from "../rocket/MessageDispatch" ;
import CallStatus from "../classes/CallStatus" ;
import DialPadView from "./DialPadView" ;
import ListWrapper from "../utils/ListWrapper" ;
import InteractionType from "../classes/InteractionType" ;
import TwilioClient from "../classes/TwilioClient" ;
import Lead from "../models/Lead" ;
import TextView from "./TextView" ;
import FailureMessage from "../classes/FailureMessage" ;
import CollectionUtils from "../utils/CollectionUtils" ;
import RecentCreatedLeads from "../classes/RecentCreatedLeads" ;
import D3EDisposable from "../rocket/D3EDisposable" ;
import LeadStatus from "../classes/LeadStatus" ;
import EventBus from "../utils/EventBus" ;
import AddNewConnectionView from "./AddNewConnectionView" ;
import DateTime from "../core/DateTime" ;
import Interaction from "../models/Interaction" ;
import RecentCreatedLeadsRequest from "../models/RecentCreatedLeadsRequest" ;
import RecentRecruiterProfileView from "./RecentRecruiterProfileView" ;
import LabelDropdown from "./LabelDropdown" ;
import HotListLeadsRequest from "../models/HotListLeadsRequest" ;
import { UsageConstants } from "../rocket/D3ETemplate" ;
import { BuildContext } from "../classes/BuildContext" ;

type _JnpScrappedInteractionsOnLeadClick = ( lead : Lead ) => void ;


  export  interface  JnpScrappedInteractionsProps extends  BaseUIProps {   key?: string ;
   user: User ;
   client: TwilioClient ;
   data: CallData ;
   onLeadClick: _JnpScrappedInteractionsOnLeadClick ;
 }

   class  _JnpScrappedInteractionsState extends  ObservableComponent<JnpScrappedInteractionsProps> {   static defaultProps = { user:null, client:null, data:null, onLeadClick:null } ;
   idController: ui.ScrollController = new ui.ScrollController() ;
   lead: Lead = null ;
   selectedLead: Lead = null ;
   request: RecentCreatedLeadsRequest = null ;
   assignedHotListQuery: HotListLeads = null ;
   assignedHotListLeads: Array<Lead> = ListWrapper.widget(this,'assignedHotListLeads') ;
   filterByStatus: string = 'All' ;
   leadsList: RecentCreatedLeads = null ;
   leads: Array<Lead> = ListWrapper.widget(this,'leads') ;
   searchText: string = '' ;
   lastInteraction: Interaction = null ;
   addConnectionPopupPopup: Popup ;
   dialPadViewPopupPopup: Popup ;
   static contextType = BuildContext ;
   context: React.ContextType<typeof BuildContext> ;
  public lastInteractionDisposable: D3EDisposable ;
 public constructor ( props : JnpScrappedInteractionsProps ) {
 super(props);

this.initState();
 }
  public get user (  ) : User {
 return this.props.user ; 
 }
  public get client (  ) : TwilioClient {
 return this.props.client ; 
 }
  public get data (  ) : CallData {
 return this.props.data ; 
 }
  public initState (  ) {
 super.initState();

this.lastInteractionDisposable=MessageDispatch.get().syncObject(this.lastInteraction,UsageConstants.SUBSCRIPTION_ONINTERACTIONCHANGE_JNPSCRAPPEDINTERACTIONS_LASTINTERACTION_SYNCHRONISE);

this.initListeners();

this.enableBuild=true;

this.onInit();
 }
  public initListeners (  ) : void {
 this.updateSyncProperty('user',this.props.user);

this.computeAssignedHotListQuery();

this.on([ 'assignedHotListQuery', 'assignedHotListQuery.items' ],this.computeAssignedHotListLeads);

this.computeAssignedHotListLeads();

this.on([ 'request', 'request.applyStatus', 'request.isScrapedData', 'request.lead', 'request.offset', 'request.pageSize', 'request.searchText', 'request.status', 'request.user' ],this.computeLeadsList);

this.computeLeadsList();

this.on([ 'leadsList', 'leadsList.items' ],this.computeLeads);

this.computeLeads();

this.updateSyncProperty('data',this.props.data);

this.on([ 'lead', 'lead.lastInteraction' ],this.computeLastInteraction);

this.computeLastInteraction();

this.on([ 'filterByStatus', 'leads', 'leadsList', 'leadsList.count', 'request', 'request.offset', 'request.pageSize', 'selectedLead' ],this.rebuild);
 }
  public componentDidUpdate ( prevProps : JnpScrappedInteractionsProps ) : void {
 super.componentDidUpdate(prevProps);

if ( prevProps.user !== this.props.user ) {
 this.updateObservable('user',prevProps.user,this.props.user);

this.fire('user',this);
 }

if ( prevProps.client !== this.props.client ) {
 this.fire('client',this);
 }

if ( prevProps.data !== this.props.data ) {
 this.updateObservable('data',prevProps.data,this.props.data);

this.fire('data',this);
 }
 }
  public setLead ( val : Lead ) : void {
 let isValChanged :boolean=this.lead !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateObservable('lead',this.lead,val);

this.lead=val;

this.fire('lead',this);
 }
  public setSelectedLead ( val : Lead ) : void {
 let isValChanged :boolean=this.selectedLead !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateObservable('selectedLead',this.selectedLead,val);

this.selectedLead=val;

this.fire('selectedLead',this);
 }
  public setRequest ( val : RecentCreatedLeadsRequest ) : void {
 let isValChanged :boolean=this.request !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateObservable('request',this.request,val);

this.request=val;

this.fire('request',this);
 }
  public setAssignedHotListQuery ( val : HotListLeads ) : void {
 let isValChanged :boolean=this.assignedHotListQuery !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateObservable('assignedHotListQuery',this.assignedHotListQuery,val);

MessageDispatch.get().dispose(this.assignedHotListQuery);

this.assignedHotListQuery=val;

this.fire('assignedHotListQuery',this);
 }
  public computeAssignedHotListQuery  =  async  (  ) : Promise<void>  =>  {
 try {
 this.setAssignedHotListQuery(( await Query.get().getHotListLeads(UsageConstants.QUERY_GETHOTLISTLEADS_JNPSCRAPPEDINTERACTIONS_PROPERTIES_ASSIGNEDHOTLISTQUERY_COMPUTATION,new HotListLeadsRequest({ isScrapedData:true }),{ 'synchronize':true })));
 }
 catch ( exception ) {
 console.log(' exception in computeAssignedHotListQuery : ' + exception.toString());

this.setAssignedHotListQuery(null);
 }
 }
  public setAssignedHotListLeads ( val : Array<Lead> ) : void {
 let isValChanged :boolean=CollectionUtils.isNotEquals(this.assignedHotListLeads,val);

if ( !isValChanged ) {
 return ; 
 }

this.updateObservableColl('assignedHotListLeads',this.assignedHotListLeads,val);

this.assignedHotListLeads.clear();

this.assignedHotListLeads.addAll(val);

this.fire('assignedHotListLeads',this);
 }
  public addToAssignedHotListLeads ( val : Lead,index : number = -1 ) : void {
 if ( index === -1 ) {
 if ( !this.assignedHotListLeads.contains(val) ) this.assignedHotListLeads.add(val);
 }
 else {
 this.assignedHotListLeads.remove(this.assignedHotListLeads.elementAt(index));

this.assignedHotListLeads.add(val);
 }

this.fire('assignedHotListLeads',this,val,true);

this.updateObservable('assignedHotListLeads',null,val);
 }
  public removeFromAssignedHotListLeads ( val : Lead ) : void {
 this.assignedHotListLeads.remove(val);

this.fire('assignedHotListLeads',this,val,false);

this.removeObservable('assignedHotListLeads',val);
 }
  public computeAssignedHotListLeads  =  (  ) : void  =>  {
 try {
 this.setAssignedHotListLeads(Array.from(this.assignedHotListQuery !== null && this.assignedHotListQuery.items !== null ? this.assignedHotListQuery.items : [  ]));
 }
 catch ( exception ) {
 console.log(' exception in computeAssignedHotListLeads : ' + exception.toString());

this.setAssignedHotListLeads([  ]);
 }
 }
  public setFilterByStatus ( val : string ) : void {
 let isValChanged :boolean=this.filterByStatus !== val;

if ( !isValChanged ) {
 return ; 
 }

this.filterByStatus=val;

this.fire('filterByStatus',this);
 }
  public setLeadsList ( val : RecentCreatedLeads ) : void {
 let isValChanged :boolean=this.leadsList !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateObservable('leadsList',this.leadsList,val);

MessageDispatch.get().dispose(this.leadsList);

this.leadsList=val;

this.fire('leadsList',this);
 }
  public computeLeadsList  =  async  (  ) : Promise<void>  =>  {
 try {
 this.setLeadsList(( await Query.get().getRecentCreatedLeads(UsageConstants.QUERY_GETRECENTCREATEDLEADS_JNPSCRAPPEDINTERACTIONS_PROPERTIES_LEADSLIST_COMPUTATION,this.request,{ 'synchronize':true })));
 }
 catch ( exception ) {
 console.log(' exception in computeLeadsList : ' + exception.toString());

this.setLeadsList(null);
 }
 }
  public setLeads ( val : Array<Lead> ) : void {
 let isValChanged :boolean=CollectionUtils.isNotEquals(this.leads,val);

if ( !isValChanged ) {
 return ; 
 }

this.updateObservableColl('leads',this.leads,val);

this.leads.clear();

this.leads.addAll(val);

this.fire('leads',this);
 }
  public addToLeads ( val : Lead,index : number = -1 ) : void {
 if ( index === -1 ) {
 if ( !this.leads.contains(val) ) this.leads.add(val);
 }
 else {
 this.leads.remove(this.leads.elementAt(index));

this.leads.add(val);
 }

this.fire('leads',this,val,true);

this.updateObservable('leads',null,val);
 }
  public removeFromLeads ( val : Lead ) : void {
 this.leads.remove(val);

this.fire('leads',this,val,false);

this.removeObservable('leads',val);
 }
  public computeLeads  =  (  ) : void  =>  {
 try {
 this.setLeads(Array.from(this.leadsList.items.isNotEmpty ? this.leadsList.items : [  ]));
 }
 catch ( exception ) {
 console.log(' exception in computeLeads : ' + exception.toString());

this.setLeads([  ]);
 }
 }
  public setSearchText ( val : string ) : void {
 let isValChanged :boolean=this.searchText !== val;

if ( !isValChanged ) {
 return ; 
 }

this.searchText=val;

this.fire('searchText',this);
 }
  public setLastInteraction ( val : Interaction ) : void {
 let isValChanged :boolean=this.lastInteraction !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateObservable('lastInteraction',this.lastInteraction,val);

this.lastInteractionDisposable?.dispose();

this.lastInteraction=val;

this.lastInteractionDisposable=MessageDispatch.get().syncObject(this.lastInteraction,UsageConstants.SUBSCRIPTION_ONINTERACTIONCHANGE_JNPSCRAPPEDINTERACTIONS_LASTINTERACTION_SYNCHRONISE);

this.fire('lastInteraction',this);
 }
  public computeLastInteraction  =  (  ) : void  =>  {
 try {
 this.setLastInteraction(this.lead.lastInteraction);
 }
 catch ( exception ) {
 console.log(' exception in computeLastInteraction : ' + exception.toString());

this.setLastInteraction(null);
 }
 }
  public render (  ) : ReactNode {
 let cStyle=this.context.theme;

return ui.Column({ crossAxisAlignment:ui.CrossAxisAlignment.start, children:[ ui.Row({ mainAxisAlignment:ui.MainAxisAlignment.spaceBetween, children:[ TextView({ data:'Recruiter Interactions', style:new ui.TextStyle({fontSize:cStyle.tTextViewHeadlineFourFontSizeOn,fontWeight:cStyle.tTextViewHeadlineFourFontWeightOn}), className:'HeadlineFour xb33', key:'0' }) ], key:'0' }), ui.Container({ className:'x462 vc', key:'1' }), ui.ListView({ controller:this.idController, children:[ ui.Row({ children:[ ui.Container({ margin:ui.EdgeInsets.fromLTRB(0.0,0.0,10.0,0.0,new Map()), child:LabelDropdown<string>({ value:this.filterByStatus, items:LeadUtils.leadStatuses, onChanged:( value ) => {
 this.onStatusFilterDropdownOnChangedHandler(value);
 }
, builder:( context,item ) => {
 return TextView({ data:item }) ; 
 }
 }), key:'0', className:'x4b2' }) ], key:'0' }), (this.leads).expand(( item ) => [ ui.Container({ margin:ui.EdgeInsets.fromLTRB(0.0,3.0,0.0,12.0,new Map()), child:RecentRecruiterProfileView({ lead:item, selectedLead:this.selectedLead, onLeadClick:( lead ) => {
 this.onRecentLeadButtonPressed(lead,item);
 }
 }), key:item?.ident, className:'xbdc6' }) ]) ], className:'xfe7 vc v', key:'2' }), PaginationView({ pageSize:this.request.pageSize, total:this.leadsList !== null ? this.leadsList.count : 0, offset:this.request.offset, onChange:( pageSize,offset ) => {
 this.onChangePaginationViewHandler(pageSize,offset);
 }
, key:'3' }) ], className:ui.join('JnpScrappedInteractions xd9c vc v ' , this.props.className ?? ''), ...copyBaseUIProps(this.props,) }) ; 
 }
  public onInit  =  (  ) : void  =>  {
 this.setRequest(new RecentCreatedLeadsRequest({ user:this.user, pageSize:50, isScrapedData:true, offset:0 }));
 }
  public onStatusFilterDropdownOnChangedHandler  =  ( value : string ) : void  =>  {
 this.setFilterByStatus(value);

if ( value !== 'All' ) {
 this.request.setStatus(LeadStatus.values.firstWhere(( e ) => e.name === value,{ orElse:(  ) => null }));
 }

this.request.setApplyStatus(value === 'All' ? false : true);

this.setRequest(this.request.deepClone());
 }
  public onChangePaginationViewHandler  =  ( pageSize : number,offset : number ) : void  =>  {
 this.request.setPageSize(pageSize);

this.request.setOffset(offset);

this.setRequest(this.request.deepClone());
 }
  public onRecentLeadButtonPressed  =  ( lead : Lead,item : Lead ) : void  =>  {
 this.onLeadClick(item);

this.setSelectedLead(item);
 }
  public onDialCallHandle  =  async  ( callingLead : Lead,user : User ) : Promise<void>  =>  {
 this.hideDialPadViewPopup();

let connectCall :boolean=( await this.client.makeCall(this.user.twilioNumber,callingLead.phone,callingLead.ext,{ onStatus:( s ) => {
 this.onStatusChange(s,callingLead);
 }
, onFailure:( m,e ) => {
 this.onConnectionFailure(m,e);
 }
 }));
 }
  public onStatusChange  =  async  ( status : string,callingLead : Lead ) : Promise<void>  =>  {
 if ( this.lastInteraction === null ) {
 this.setLastInteraction(new Interaction({ lead:callingLead, fromNumber:this.user.twilioNumber, toNumber:callingLead.phone, callStatus:CallStatus.Initiated, type:InteractionType.Call, sid:this.client.callSid, isIncoming:false, handledBy:this.user }));

EventBus.get().fire(new CallInteraction({ interaction:this.lastInteraction, data:this.data, lead:callingLead }));

let result :Result<Interaction>=( await this.lastInteraction.save());

if ( result.status === ResultStatus.Success ) {
  }
 }
 else if ( this.lastInteraction !== null ) {
 let st :CallStatus=CallStatus.Initiated;

switch ( status ) {
 case 'ringing' : {
 st=CallStatus.Ringing;
 break; }

case 'completed' : {
 st=CallStatus.Completed;
 break; }

case 'accepted' : {
 {
 st=CallStatus.InProgress;

this.lastInteraction.setStartTime(DateTime.now());
 }
 break; }

case 'failed' : {
 st=CallStatus.Failed;
 break; }

case 'busy' : {
 st=CallStatus.Busy;
 break; }

case 'open' : {
 st=CallStatus.InProgress;
 break; }

case 'connecting' : {
 st=CallStatus.Connecting;
 break; }

case 'initiated' : {
 st=CallStatus.Initiated;
 break; }
 default: {
  }
 }

this.lastInteraction.setCallStatus(st);
 }
 }
  public onConnectionFailure  =  ( message : string,error : string ) : void  =>  {
 EventBus.get().fire(new FailureMessage({ message:message }));
 }
  public get onLeadClick (  ) : _JnpScrappedInteractionsOnLeadClick {
 return this.props.onLeadClick ; 
 }
  public dispose (  ) : void {
 this.lastInteractionDisposable?.dispose();

MessageDispatch.get().dispose(this.assignedHotListQuery);

MessageDispatch.get().dispose(this.leadsList);

this.addConnectionPopupPopup?.dispose();

this.dialPadViewPopupPopup?.dispose();

super.dispose();
 }
  public showAddConnectionPopup ( d3eParams ? : Partial<{autoClose: boolean, model: boolean, float: boolean, takeFocus: boolean}> ) : void {
 let autoClose=d3eParams?.autoClose;

let model=d3eParams?.model;

let float=d3eParams?.float;

let takeFocus=d3eParams?.takeFocus;

this.addConnectionPopupPopup ?. dispose();

this.addConnectionPopupPopup=new Popup({autoClose:autoClose,model:model,float:float,takeFocus:takeFocus,position:ui.PopUpPosition.Center,child:ui.Container({ width:550, child:AddNewConnectionView({ lead:this.lead, user:this.user }), className:'xf24 hc vc' })});

this.addConnectionPopupPopup.showPopup(this.context);
 }
  public showDialPadViewPopup ( d3eParams ? : Partial<{autoClose: boolean, model: boolean, float: boolean, takeFocus: boolean}> ) : void {
 let autoClose=d3eParams?.autoClose;

let model=d3eParams?.model;

let float=d3eParams?.float;

let takeFocus=d3eParams?.takeFocus;

this.dialPadViewPopupPopup ?. dispose();

this.dialPadViewPopupPopup=new Popup({autoClose:autoClose,model:model,float:float,takeFocus:takeFocus,position:ui.PopUpPosition.Center,child:ui.Container({ height:450, width:300, child:DialPadView({ client:this.client, user:this.user, onCallConnect:( callingLead,user ) => {
 this.onDialCallHandle(callingLead,user);
 }
 }), className:'x853 hc vc' })});

this.dialPadViewPopupPopup.showPopup(this.context);
 }
  public hideAddConnectionPopup (  ) : void {
 this.addConnectionPopupPopup ?. dispose();
 }
  public hideDialPadViewPopup (  ) : void {
 this.dialPadViewPopupPopup ?. dispose();
 }
 }
export default function JnpScrappedInteractions ( props : JnpScrappedInteractionsProps ) {
 return React.createElement(_JnpScrappedInteractionsState,{ ..._JnpScrappedInteractionsState.defaultProps, ...props }) ; 
 }
